let languages = [
    {
        name: 'english',
        value: 'en'
    },
    {
        name: 'bahasa indonesia',
        value: 'id'
    },
    {
        name: 'deutsch',
        value: 'de'
    },
    {
        name: 'español',
        value: 'es'
    },
    {
        name: 'italiano',
        value: 'it'
    },
    {
        name: '日本語',
        value: 'ja'
    },
    {
        name: 'polski',
        value: 'pl'
    },
    {
        name: 'pусский',
        value: 'ru'
    },
    {
        name: 'français',
        value: 'fr'
    },
    {
        name: 'nederlands',
        value: 'nl'
    },
    {
        name: "العربية",
        value: "ar"
    }, 
    {
        name: "dansk",
        value: "da"
    }, 
    {
        name: "português",
        value: "pt"
    }, 
    {
        name: "türkçe",
        value: "tr"
    }, 
    {
        name: "中文",
        value: "zh"
    }
];

export default languages;